import { Box } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { BAR_SCALE, LEVEL_TONE } from '../utils/constants';

/** Load against capacity: the track is drawn to 150%, a tick marks 100%, and the fill takes the level's colour. */
export default function LoadBar({ pct, level, height = 8 }) {
  return (
    <Box sx={{ position: 'relative', flex: 1, minWidth: 60, height, borderRadius: 999, bgcolor: '#EFEDE6', overflow: 'visible' }}>
      <Box sx={{ position: 'absolute', inset: 0, right: 'auto', width: `${Math.min(100, (pct / BAR_SCALE) * 100)}%`, borderRadius: 999, bgcolor: LEVEL_TONE[level].accent }} />
      <Box aria-hidden sx={{ position: 'absolute', top: -3, bottom: -3, left: `${(100 / BAR_SCALE) * 100}%`, width: 2, borderRadius: 1, bgcolor: WD.ink, opacity: 0.55 }} />
    </Box>
  );
}
